// extracted by mini-css-extract-plugin
module.exports = {"package-table-div":"package-table-div-81d37bac92f5fc1cbd59bee08f846b7f","package-table":"package-table-4212966f41b44df0a86a820dd780d779"};